import palette from 'theme/palette'
import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  termsToPolicy: {
    '& .MuiCheckbox-colorPrimary.Mui-checked': {
      color: palette.subscription.primary.main,
    },
  },
  helperTextFontSize: {
    fontSize: '9px',
  },
}))

export default styles
